/**
 * Masks a string (typically a phone number), showing only the last 4 characters.
 * @param {string} text - The string to mask.
 * @returns {string} The masked string (e.g., "******1234").
 */
export function maskPhone(text) {
  if (!text) return '';
  const str = String(text);
  if (str.length <= 4) return str;
  return '*'.repeat(str.length - 4) + str.slice(-4);
}
